import React from "react";

const MonthlyViews = ({
  style = {},
  width = 30,
  height = 30,
  className = "",
  color = "#fff",
  viewBox = "0 0 24 24",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      style={style}
      fill={color}
      {...rest}
    >
      <title>Monthly Views</title>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M12 13l4 1 2 2v2H6v-2l2-2 4-1zm-8 0l2-2-2-2-2 2 2 2zm1 1a7 7 0 00-4 1l-1 1v2h5v-2-2zm15-1l2-2-2-2-2 2 2 2zm4 3l-1-1a7 7 0 00-4-1l1 2v2h4v-2zM12 6a3 3 0 110 6 3 3 0 010-6z" />
    </svg>
  );
};

export default MonthlyViews;
